export default __webpack_public_path__ + "locales/uk-UA/Files.json?hash=514c450a8faea4a4c76e0a4fd93ef541";